import { attempt, isError } from 'lodash'

// 通过 Url 获取参数
export function getUrlParamsByKey(key) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(key)
}

// 带异常捕获的 JSON 数据解析
export function parseJSON(json) {
    const parsedData = attempt(JSON.parse, json)
    if (!isError(parsedData)) {
        return parsedData || {}
    } else {
        return {}
    }
}

// 通过 Url 参数设置全局参数
export function setStoreByUrlParams() {
    return new Promise((resolve, reject) => {
        const formAppName = getUrlParamsByKey('formAppName')
        if (!formAppName) return resolve(null) // 非外链模式直接返回
        const targetMapId = getUrlParamsByKey('targetMapId')
        const useTabbar = getUrlParamsByKey('useTabbar')
        const documentTitle = getUrlParamsByKey('documentTitle')
        try {
            sessionStorage.setItem(
                'formAppInfo',
                JSON.stringify({
                    formAppName,
                    targetMapId,
                    useTabbar: useTabbar === 'true' ? true : false,
                    documentTitle,
                })
            )
            // 移除 URL 参数
            // window.history.replaceState({}, document.title, window.location.href.split('?')[0])
            resolve(null)
        } catch (e) {
            reject(e)
        }
    })
}

// 获取外部应用传递的信息
export function getFormAppInfo() {
    const { formAppName, targetMapId, useTabbar, documentTitle } = parseJSON(
        sessionStorage.getItem('formAppInfo') || '{}'
    )
    return {
        formAppName: formAppName || getUrlParamsByKey('formAppName'),
        targetMapId: targetMapId || getUrlParamsByKey('targetMapId'),
        useTabbar: useTabbar || getUrlParamsByKey('useTabbar'),
        documentTitle: documentTitle || getUrlParamsByKey('documentTitle'),
    }
}

// 判定是否来自「微甄房小程序」应用
export function isFromCrmApplet() {
    return getFormAppInfo()?.formAppName === 'crmApplet'
}

// 判定是否使用「微甄房小程序」Tabbar
export function isUseTabbar() {
    return getFormAppInfo()?.useTabbar?.toString() === 'true'
}

// 判定是否来自「微观E家」应用
export function isFromCrmFamily() {
    return getFormAppInfo()?.formAppName === 'crmFamily' && window?.ipcRenderer
}
